import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import {
  Button,
  BUTTON_SIZE_LG,
  BUTTON_VARIANT_PRIMARY
} from '../Button'

import { Link } from '../link/Link'

import './EmptyState.scss'

export const EmptyState = ({
  title,
  description,
  thumbSrc,
  buttonText,
  linkText,
  onClickButton,
  onClickLink,
  className,
  children,
  'data-mu-test': dataAttributeTest
}) => {
  return (
    <div
      className={classnames('b-empty-state', className)}
      data-mu-test={classnames('emptystate', dataAttributeTest)}
    >
      {thumbSrc && (
        <div
          className='b-empty-state__visual'
          style={{
            backgroundImage: `url(${thumbSrc})`
          }}
        />
      )}
      <div className='b-empty-state__content'>
        {title && <h3 className='b-empty-state__title'>{title}</h3>}
        {description && (
          <p className='b-empty-state__description'>{description}</p>
        )}
        {children}
        {(buttonText || linkText) && (
          <div className='row m-bottom-0'>
            {buttonText && (
              <Button
                size={BUTTON_SIZE_LG}
                kind={BUTTON_VARIANT_PRIMARY}
                onClick={onClickButton}
                data-mu-test='b-empty-state__button'
              >
                {buttonText}
              </Button>
            )}
            {linkText && (
              <Link
                className='textlink b-empty-state__link'
                data-mu-test='b-empty-state__link'
                onClick={onClickLink}
              >
                {linkText}
              </Link>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

EmptyState.defaultProps = {
  buttonText: ''
}

EmptyState.propTypes = {
  title: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  thumbSrc: PropTypes.string,
  buttonText: PropTypes.string,
  onClickButton: PropTypes.func,
  children: PropTypes.any,
  className: PropTypes.string,
  /**
   * Additional values for data-attribute used for tests and tracking
   **/
  'data-mu-test': PropTypes.string
}
